<template>
    <div class="form modal" v-if="show">
        <div class="box" v-click-outside="closeModal">
            <div class="contents">
                <div class="complete">
                    <div class="icon" v-if="this.iconFlag"></div>
                    <h3>{{ this.message }}</h3>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vClickOutside from 'click-outside-vue3'
export default {
    props: {
        message: {
            type: String,
            required: false,
            default: '更新が完了しました'
        },
        emailFlag: {
            type: Boolean,
            required: false,
            default: false
        },
        iconFlag: {
          type: Boolean,
          required: false,
          default: true
        }
    },
    data() {
        return {
            show: false
        }
    },
    mounted() {
        this.showModal()
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
    methods: {
        showModal() {
            this.show = true

            setTimeout(() => {
              this.closeModal()

              if (this.emailFlag) {
                window.location.href = '/mypage/account/email';
              }
            }, 2000);
        },
        closeModal() {
            this.show = false
        }
    }
}
</script>
